
    // This file is auto generated
    export const iconsListData = [
  {
    "name": "asterisk",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "avatar-circle",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "bell",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-notification": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-down",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-left",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-right",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-up",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "cog",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "cross",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "ellipsis",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "eye-striked",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "file-pdf",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "list",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "minus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "notification-error",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-information",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-information": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-warning",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-warning": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "octagon-lightning",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "pencil-square",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "plus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "question-mark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "sort",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "square-info",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "info": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "tiles",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "triangle-warning",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  }
]
    